import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.857 1.667c.937.002 1.413.007 1.824.019l.162.006c.186.006.37.015.593.025.886.041 1.492.181 2.022.387.55.212 1.014.498 1.477.961.424.416.752.92.96 1.477.207.53.347 1.135.388 2.023.01.222.019.406.025.593l.005.162c.013.41.018.886.02 1.823v1.714a65.58 65.58 0 01-.019 1.823l-.005.162a63.17 63.17 0 01-.025.593c-.041.887-.183 1.492-.388 2.023a4.084 4.084 0 01-.961 1.477c-.416.424-.92.752-1.477.96-.53.207-1.136.347-2.022.388l-.594.025-.161.005c-.411.012-.887.018-1.824.02H9.145a64.871 64.871 0 01-1.825-.019l-.162-.005a51.06 51.06 0 01-.593-.026c-.887-.041-1.492-.181-2.023-.387a4.083 4.083 0 01-1.476-.961 4.083 4.083 0 01-.962-1.477c-.206-.53-.346-1.136-.387-2.023l-.025-.593-.004-.162a65.816 65.816 0 01-.021-1.823V9.143c-.003-.608.003-1.215.018-1.823l.006-.162.025-.593c.042-.888.182-1.492.387-2.023.21-.557.539-1.06.964-1.477.416-.424.919-.752 1.475-.96.531-.207 1.136-.347 2.023-.388.222-.01.407-.019.593-.025l.162-.005a65.813 65.813 0 011.823-.02h1.714zM10 5.833a4.167 4.167 0 100 8.334 4.167 4.167 0 000-8.334zM10 7.5a2.5 2.5 0 110 5 2.5 2.5 0 010-5m4.376-2.917a1.042 1.042 0 100 2.083 1.042 1.042 0 000-2.083z"
        fill={props.color ?? "#23262F"}
      />
    </svg>
  );
}

export default SvgComponent;
